import { HeartFilled, StarFilled } from "@ant-design/icons";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import React from "react";
import { convertToVnd } from "../utils/function";
import { priceFormat, queryParams } from "../utils";
import SImage from "./SImage";
import { Skeleton } from "antd";

export default function ProductItem({ product }) {
  let [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  return (
    <button
      onClick={() => {
        navigate(`/product-details?drugId=${product.drug_id}`);
      }}
    >
      <div className="w-full h-full bg-white shadow-lg p-2 relative rounded-xl hover:shadow-2xl">
        <div className="flex flex-col justify-between h-full">       <div>
 
            <div className="sm:h-[219px] h-[130px] bg-[#F9F9F9] rounded-xl flex items-center justify-center">
              <SImage className="w-full h-full  object-cover" src={product.image} alt="" />
            </div>
            
          </div>

          <div className="flex flex-col flex-1 text-left ">
            <p className="font-bold text-two-lines text-main-blue text-[10px] sm:text-[14px] ">{product.drug_name}</p>
            {product.category_name && (
              <p className="font-bold text-two-lines hover:text-main-blue text-[9px] sm:text-[12px]">
                {product.category_name}
              </p>
            )}
            {product.company && (
              <p className="mt-1 text-xs text-two-lines text-[8px] sm:text-[12px]">Sản xuất: {product.company}</p>
            )}

            <div className="flex items-center justify-between mt-auto">
              <h5 className="font-bold sm:text-[18px] text-[16px] text-[#2297D4]">
                {priceFormat(product.units?.out_price)}
              </h5>
              {product.units?.out_price_org && product.units?.out_price_org > 0 ? (
                <span className="price-old sm:text-[14px] text-[12px]">{priceFormat(product.units.out_price_org)}</span>
              ) : null}
            </div>
          </div>
          
          {/* <div className="flex items-center justify-center mt-1.5">
            <div className="text-white flex items-center cursor-pointer bg-[#08AF37] px-2 py-1 rounded-3xl	">
              <span className="font-bold text-[10px]">Xem chi tiết ></span>
            </div>
          </div> */}
        </div>
      </div>
    </button>
  );
}
